import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { TableRow } from '@material-ui/core';
export var StyledTableRow = styled(TableRow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    background-color: #f0f0f7;\n    cursor: pointer;\n  }\n\n  td {\n    vertical-align: top;\n  }\n"], ["\n  &:hover {\n    background-color: #f0f0f7;\n    cursor: pointer;\n  }\n\n  td {\n    vertical-align: top;\n  }\n"])));
var templateObject_1;
